import React from 'react';
import { TbFileSearch } from "react-icons/tb";
import { IoPeopleOutline } from "react-icons/io5";
import { FaPeopleGroup } from 'react-icons/fa6';
import { CLIENT, PROFESSIONAL, ASSISTANT, FUNDER, FIRM } from 'Constants';
import { Building2 } from 'lucide-react';

function ClientIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#14213d" strokeWidth="1.6" className="flex-none">
      <circle cx="9" cy="8" r="3.4" />
      <path d="M3.5 20c0-3.6 2.9-6 5.5-6s5.5 2.4 5.5 6" />
      <circle cx="18.5" cy="17.5" r="3" />
      <path d="M20.6 19.6L23 22" />
    </svg>
  )
}

// All five roles are built and kept here so re-enabling one later is a one-line change.
// For first launch, only CLIENT and FIRM are shown to users (see LAUNCH_ROLES below).
const roleOptions = [
  { role: CLIENT, Icon: ClientIcon, text: "I'm a Potential Client, looking for an Attorney." },
  { role: PROFESSIONAL, Icon: TbFileSearch, text: "I'm a Licensed Attorney, looking to find cases that match my expertise." },
  { role: ASSISTANT, Icon: IoPeopleOutline, text: "I'm a Legal Assistant, acting on behalf of an Attorney." },
  { role: FUNDER, Icon: FaPeopleGroup, text: "We are a Litigation Funder, looking to fund cases." },
  { role: FIRM, Icon: Building2, text: "We are a Law Firm, looking to find case leads that match our expertise." },
]

// Launch scope: only these roles are shown in the picker.
export const LAUNCH_ROLES = [CLIENT, FIRM]

function SignupRole({ roleType, setRoleType, setShowForm }) {
  const getRegisterText = () => {
    switch (roleType) {
      case CLIENT: return "Register as a Potential Client";
      case PROFESSIONAL: return "Register as a Licensed Attorney";
      case ASSISTANT: return "Register as a Legal Assistant";
      case FUNDER: return "Register as a Litigation Funder";
      case FIRM: return "Register as a Law Firm";
      default: return "Create account";
    }
  }

  return (
    <div className="w-full font-plexsans">
      <div className="flex flex-col gap-3 mt-2">
        {roleOptions.filter(({ role }) => LAUNCH_ROLES.includes(role)).map(({ role, Icon, text }) => {
          const selected = roleType === role;
          return (
            <div
              key={role}
              onClick={() => setRoleType(role)}
              className={
                'bg-ivory rounded-sm p-5 cursor-pointer transition-colors border' +
                (selected ? ' border-[1.5px] border-tan' : ' border-navy/[0.16]')
              }
            >
              <div className="flex justify-between items-start mb-4">
                <Icon className="text-[22px]" style={{ color: selected ? '#14213d' : 'rgba(20,33,61,.7)' }} />
                <span
                  className={
                    'w-[19px] h-[19px] rounded-full border-[1.5px] flex-none relative' +
                    (selected ? ' border-tan bg-tan' : ' border-navy/30')
                  }
                >
                  {selected && <span className="absolute inset-[5px] rounded-full bg-ivory" />}
                </span>
              </div>
              <p className="m-0 font-plexsans text-[14.5px] leading-[1.5] text-navy">{text}</p>
            </div>
          )
        })}
      </div>

      <div className="flex items-center justify-center mt-7">
        {roleType ? (
          <button
            onClick={() => setShowForm(true)}
            className="w-full font-plexsans font-medium text-[14px] text-ivory bg-tan hover:bg-tanDark rounded-sm py-3.5 cursor-pointer transition-colors"
          >
            {getRegisterText()}
          </button>
        ) : (
          <button disabled className="w-full font-plexsans font-medium text-[14px] text-navy/40 bg-navy/10 rounded-sm py-3.5 cursor-not-allowed">
            Create account
          </button>
        )}
      </div>
    </div>
  )
}

export default SignupRole
